import {PartialGameRequestParams} from "../../../domain/partial-game/models/partial-game.request-params";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {ScoresListWidgetController} from "../scores-list-widget.controller";
import {ScoresListWidgetState} from "../models/scores-list-widget.state";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {CompetitionsDomainService} from "../../../domain/competitions/services/competitions.domain-service";
import {CompetitionsRequestParams} from "../../../domain/competitions/models/competitions.request-params";
import {SCORES_LIST_WIDGET} from "../scores-list-widget.consts";

export class ScoresListWidgetCompetitionsFetchHandler extends FetchHandler {
  type = SCORES_LIST_WIDGET.ACTION_TYPES.competitionsFetch;
  controller: ScoresListWidgetController;
  state: ScoresListWidgetState;
  _service: CompetitionsDomainService;

  static injectables = [CompetitionsDomainService];


  constructor(service: CompetitionsDomainService) {
    super(service);

    this._service = service;
  }

  get requestParams(): BaseApiRequestParams {
    const competitionIds: Array<Number> = this.controller.props.competitionIds;
    const requestParams: PartialGameRequestParams = new CompetitionsRequestParams(null, competitionIds);

    return requestParams;
  }

  async action(params) {
    const dataSource = await this.fetch();

    this.state.competitionsDataSource = dataSource;

    return dataSource;
  }
}
